export default __webpack_public_path__ + "static/media/BatteryChange.cbc757bb.svg";